<section class="sidenav-section devspace-elements-gap" aria-labelledby="channels-heading">
  <header class="section-header">
    <button
      type="button"
      class="section-toggle-button"
      (click)="channelsOpen = !channelsOpen"
      [attr.aria-expanded]="channelsOpen"
      aria-controls="channels-content"
    >
      <svg
        class="section-toggle-arrow"
        aria-hidden="true"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1248 17.875L10.8748 14.625C10.479 14.2292 10.3907 13.7762 10.6098 13.2662C10.8282 12.7554 11.2186 12.5 11.7811 12.5H18.2186C18.7811 12.5 19.1715 12.7554 19.3898 13.2662C19.609 13.7762 19.5207 14.2292 19.1248 14.625L15.8748 17.875C15.7498 18 15.6144 18.0937 15.4686 18.1562C15.3227 18.2187 15.1665 18.25 14.9998 18.25C14.8332 18.25 14.6769 18.2187 14.5311 18.1562C14.3852 18.0937 14.2498 18 14.1248 17.875Z"
          fill="currentColor"
        />
      </svg>
      <svg
        class="section-title-icon"
        aria-hidden="true"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 21C4.9 21 3.95833 20.6083 3.175 19.825C2.39167 19.0417 2 18.1 2 17C2 15.9 2.39167 14.9583 3.175 14.175C3.95833 13.3917 4.9 13 6 13C7.1 13 8.04167 13.3917 8.825 14.175C9.60833 14.9583 10 15.9 10 17C10 18.1 9.60833 19.0417 8.825 19.825C8.04167 20.6083 7.1 21 6 21ZM18 21C16.9 21 15.9583 20.6083 15.175 19.825C14.3917 19.0417 14 18.1 14 17C14 15.9 14.3917 14.9583 15.175 14.175C15.9583 13.3917 16.9 13 18 13C19.1 13 20.0417 13.3917 20.825 14.175C21.6083 14.9583 22 15.9 22 17C22 18.1 21.6083 19.0417 20.825 19.825C20.0417 20.6083 19.1 21 18 21ZM6 19C6.55 19 7.02067 18.8043 7.412 18.413C7.804 18.021 8 17.55 8 17C8 16.45 7.804 15.9793 7.412 15.588C7.02067 15.196 6.55 15 6 15C5.45 15 4.97933 15.196 4.588 15.588C4.196 15.9793 4 16.45 4 17C4 17.55 4.196 18.021 4.588 18.413C4.97933 18.8043 5.45 19 6 19ZM18 19C18.55 19 19.021 18.8043 19.413 18.413C19.8043 18.021 20 17.55 20 17C20 16.45 19.8043 15.9793 19.413 15.588C19.021 15.196 18.55 15 18 15C17.45 15 16.979 15.196 16.587 15.588C16.1957 15.9793 16 16.45 16 17C16 17.55 16.1957 18.021 16.587 18.413C16.979 18.8043 17.45 19 18 19ZM12 11C10.9 11 9.95833 10.6083 9.175 9.825C8.39167 9.04167 8 8.1 8 7C8 5.9 8.39167 4.95833 9.175 4.175C9.95833 3.39167 10.9 3 12 3C13.1 3 14.0417 3.39167 14.825 4.175C15.6083 4.95833 16 5.9 16 7C16 8.1 15.6083 9.04167 14.825 9.825C14.0417 10.6083 13.1 11 12 11ZM12 9C12.55 9 13.021 8.804 13.413 8.412C13.8043 8.02067 14 7.55 14 7C14 6.45 13.8043 5.97933 13.413 5.588C13.021 5.196 12.55 5 12 5C11.45 5 10.9793 5.196 10.588 5.588C10.196 5.97933 10 6.45 10 7C10 7.55 10.196 8.02067 10.588 8.412C10.9793 8.804 11.45 9 12 9Z"
          fill="currentColor"
        />
      </svg>
      <h3 id="channelsHeading" class="section-title-text">Channels</h3>
      <span class="dm-total-badge" *ngIf="totalUnreadChannels > 0">
        {{ totalUnreadChannels }}
      </span>
    </button>

    <button
      (click)="openAddChannel()"
      class="section-addon-button"
      type="button"
      aria-label="Create new channel"
    >
      <svg
        aria-hidden="true"
        width="32"
        height="32"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 19C11.7167 19 11.4793 18.904 11.288 18.712C11.096 18.5207 11 18.2833 11 18V13H6C5.71667 13 5.479 12.904 5.287 12.712C5.09567 12.5207 5 12.2833 5 12C5 11.7167 5.09567 11.479 5.287 11.287C5.479 11.0957 5.71667 11 6 11H11V6C11 5.71667 11.096 5.479 11.288 5.287C11.4793 5.09567 11.7167 5 12 5C12.2833 5 12.521 5.09567 12.713 5.287C12.9043 5.479 13 5.71667 13 6V11H18C18.2833 11 18.5207 11.0957 18.712 11.287C18.904 11.479 19 11.7167 19 12C19 12.2833 18.904 12.5207 18.712 12.712C18.5207 12.904 18.2833 13 18 13H13V18C13 18.2833 12.9043 18.5207 12.713 18.712C12.521 18.904 12.2833 19 12 19Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </header>

  @if(channelsOpen) {
  <div id="channelsContent" class="section-content-wrapper devspace-elements-gap">
    <ul class="item-list" role="list">
      @for (channel of visibleChannels; track channel.id) {
      <li>
        <app-channel-item
          (click)="viewStateService.currentView = 'chat'"
          [channel]="channel"
          [meUid]="meUid"
        ></app-channel-item>
      </li>
      }
    </ul>

    @if (hiddenChannelsCount > 0) {
    <button type="button" class="load-more-button" (click)="loadMoreChannels()">
      <span class="more-pill">+{{ hiddenChannelsCount }}</span>
      <span class="name">weitere anzeigen</span>
    </button>
    }

    <footer class="section-footer">
      <button (click)="openAddChannel()" class="add-item-button" type="button">
        <svg
          aria-hidden="true"
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          stroke="currentColor"
          stroke-width="0"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 17.5C12.2833 17.5 12.521 17.404 12.713 17.212C12.9043 17.0207 13 16.7833 13 16.5V13.5H16.025C16.3083 13.5 16.5417 13.404 16.725 13.212C16.9083 13.0207 17 12.7833 17 12.5C17 12.2167 16.904 11.979 16.712 11.787C16.5207 11.5957 16.2833 11.5 16 11.5H13V8.475C13 8.19167 12.9043 7.95833 12.713 7.775C12.521 7.59167 12.2833 7.5 12 7.5C11.7167 7.5 11.4793 7.59567 11.288 7.787C11.096 7.979 11 8.21667 11 8.5V11.5H7.975C7.69167 11.5 7.45833 11.5957 7.275 11.787C7.09167 11.979 7 12.2167 7 12.5C7 12.7833 7.09567 13.0207 7.287 13.212C7.479 13.404 7.71667 13.5 8 13.5H11V16.525C11 16.8083 11.096 17.0417 11.288 17.225C11.4793 17.4083 11.7167 17.5 12 17.5ZM12 22.5C10.6167 22.5 9.31667 22.2373 8.1 21.712C6.88333 21.1873 5.825 20.475 4.925 19.575C4.025 18.675 3.31267 17.6167 2.788 16.4C2.26267 15.1833 2 13.8833 2 12.5C2 11.1167 2.26267 9.81667 2.788 8.6C3.31267 7.38333 4.025 6.325 4.925 5.425C5.825 4.525 6.88333 3.81233 8.1 3.287C9.31667 2.76233 10.6167 2.5 12 2.5C13.3833 2.5 14.6833 2.76233 15.9 3.287C17.1167 3.81233 18.175 4.525 19.075 5.425C19.975 6.325 20.6873 7.38333 21.212 8.6C21.7373 9.81667 22 11.1167 22 12.5C22 13.8833 21.7373 15.1833 21.212 16.4C20.6873 17.6167 19.975 18.675 19.075 19.575C18.175 20.475 17.1167 21.1873 15.9 21.712C14.6833 22.2373 13.3833 22.5 12 22.5ZM12 20.5C14.2167 20.5 16.1043 19.721 17.663 18.163C19.221 16.6043 20 14.7167 20 12.5C20 10.2833 19.221 8.39567 17.663 6.837C16.1043 5.279 14.2167 4.5 12 4.5C9.78333 4.5 7.896 5.279 6.338 6.837C4.77933 8.39567 4 10.2833 4 12.5C4 14.7167 4.77933 16.6043 6.338 18.163C7.896 19.721 9.78333 20.5 12 20.5Z"
            fill="currentColor"
          />
        </svg>
        <span class="add-item-label">Channel hinzufügen</span>
      </button>
    </footer>
  </div>
  }
</section>
